import type { RaceStatus } from '../types';

export const STATUS_LABELS: Record<RaceStatus, string> = {
  open: '접수중',
  upcoming: '예정',
  closed: '마감',
  completed: '완료',
};
